/**
  * 蓝色单横向柱状图
  * @param unit 单位
  * @param xData []数据value
  * @param yData []name值
*/
import { dealBigNum } from "@/assets/js/utils";
import router from '@/router'
export function setOption(paramObj) {
  let option = {
    legend: {
      show: false,
    },
    tooltip: {
      trigger: "axis",
      borderColor: "#62FFFF",
      formatter:function (params) {
        let result = '';
        params.forEach(function (item) {
          result = item.name +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit
        });
        return result;
      },
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "1%",
      right: "1%",
      bottom: "1%",
      top:  "1%",
      containLabel: true,
    },
    xAxis: [
      {
        splitLine: {
          show: false,
        },
        type: "value",
        show: false,
      },
    ],
    yAxis: [
      {
        splitLine: {
          show: false,
        },
        axisLine: {
          //y轴
          show: false,
        },
        type: "category",
        axisTick: {
          show: false,
        },
        inverse: true,
        data: paramObj.yData,
        axisLabel: {
          color: "#8C8C8C",
          fontSize: 14,
        },
      },
    ],
    series: [
      {
        name: "",
        type: "bar",
        barMaxWidth: 16,
        label: {
          show: false,
          position: "center", // 位置
          color: "#fff",
          fontSize: 12,
          lineHeight: 20,
          distance: 15, // 距离
          formatter: "    {c}", // 这里是数据展示的时候显示的数据
        }, // 柱子上方的数值
        itemStyle: {
          borderRadius: [20, 20, 20, 20], // 圆角（左上、右上、右下、左下）
          color: {
            x: 1,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "#92D0FA", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#59A3F3", // 100% 处的颜色
              },
            ],
          },
        },
        data: paramObj.xData,
        animation: router.currentRoute.path == "/energyReport" ? false : true,
      },
    ],
  };

  return option
  
}